/**
 * Backward-compatible alias for DataSorting.
 * @see DataSorting
 */
export { default } from './DataSorting';
